import { compose } from 'recompose';

import Button from './button';

const enhance = compose();

export default enhance(Button);
